const MERCURE_HUB_URL = document.head.querySelector('link[rel="mercure-hub"]')!.getAttribute('href')!

type Data = {
    [key: string]: string | number | boolean | Data
}

type MessageListener = (data: Data) => void
const eventListeners: { [topic: string]: Array<MessageListener> } = {}

let eventSource: EventSource | null = null

function reloadEventSource () {
    const hubUrl = new URL(MERCURE_HUB_URL)
    for (const topic in eventListeners) {
        if (eventListeners[topic].length === 0) {
            continue
        }

        hubUrl.searchParams.append('topic', topic)
    }

    if (eventSource !== null) {
        if (eventSource.url === hubUrl.toString()) { // useful when you leave a page and immediately come back
            return
        }

        eventSource.close()
    }

    eventSource = new EventSource(hubUrl)
    eventSource.onmessage = event => {
        const data = JSON.parse(event.data)

        if (!eventListeners.hasOwnProperty(data['@id'])) {
            return
        }

        for (const listener of eventListeners[data['@id']]) {
            listener(data)
        }
    }
}

export function subscribe (topic: string, listener: MessageListener): void {
    if (!eventListeners.hasOwnProperty(topic)) {
        eventListeners[topic] = []
    }

    eventListeners[topic].push(listener)
    reloadEventSource()
}

export function unsubscribe (topic: string, listener: MessageListener) {
    if (!eventListeners.hasOwnProperty(topic)) {
        return
    }

    eventListeners[topic].splice(eventListeners[topic].indexOf(listener), 1)
}
